module.exports = __webpack_public_path__ + "img/conoce.f99192cc.png";